import { z } from 'zod';

export const RACHEL_AGENT_APPROVAL_DATA_NAME = 'rachel-agent-approval' as const;
export const RACHEL_AGENT_APPROVAL_DATA_PART = `data-${RACHEL_AGENT_APPROVAL_DATA_NAME}` as const;

export const RachelAgentApprovalPayloadSchema = z.object({
  toolName: z.string().min(1),
  approvalId: z.string().min(1),
  input: z.unknown().optional(),
});

export type RachelAgentApprovalPayload = z.infer<typeof RachelAgentApprovalPayloadSchema>;
